import React from 'react';

import { shape, string } from 'prop-types';

import BaseComponent from '../../.internal/BaseComponent';

import './Image.scss';

/**
 * @deprecated
 */
export default class Image extends BaseComponent {
  render() {
    const { src, alt, style, loading, id, className } = this.props;

    return (
      <img
        style={style}
        src={src}
        alt={alt}
        loading={loading}
        id={id}
        className={`Image ${className}`}
      />
    );
  }
}

Image.propTypes = {
  src: string,
  alt: string,
  style: shape({}),
  loading: string,
  id: string,
  className: string
};

Image.defaultProps = {
  src: undefined,
  alt: undefined,
  style: {},
  loading: 'eager',
  id: undefined,
  className: undefined
};
